import { motion } from 'framer-motion';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/q7RnjxXyHz353QdkW84P8k/IMG_5459.jpg';
const GOLD = '#C9A96E';
export function TransitionBlock() {
  return <section className="relative overflow-hidden px-5 sm:px-6 pt-12 pb-8 sm:pt-16 sm:pb-10 lg:pt-20 lg:pb-12 bg-nude-light" data-id="element-424" data-mp="31f0lmiqi4b81">
      {/* Brand watermark */}
      <img src={LOGO_URL} alt="" aria-hidden="true" loading="lazy" decoding="async" className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[150%] max-w-[400px] sm:max-w-[600px] lg:max-w-[820px] mix-blend-multiply opacity-[0.05] z-0" data-id="element-425" data-mp="2wfnwfrc5qs2a" />

      <div className="relative z-10 max-w-2xl mx-auto text-center" data-id="element-426" data-mp="2dhbg9lmtwhx7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-427" data-mp="2dj61z25xce2c">
          <p className="text-[11px] sm:text-xs font-sans font-medium uppercase tracking-[0.25em] sm:tracking-[0.3em] mb-4 sm:mb-5" style={{
          color: GOLD
        }} data-id="element-428" data-mp="bqq47zn2ptnq">
            Tu esencial de belleza
          </p>

          <h2 className="font-serif text-luxury-black mb-5 sm:mb-6" style={{
          fontSize: 'clamp(1.875rem, 5.5vw, 3rem)',
          lineHeight: 1.12
        }} data-id="element-429" data-mp="30oou7oefwiy4">
            Todo en su lugar. Todo listo para ti.
          </h2>

          <p className="font-sans font-light text-gray-600 mx-auto max-w-[46ch]" style={{
          fontSize: 'clamp(1rem, 1.6vw, 1.125rem)',
          lineHeight: 1.6
        }} data-id="element-430" data-mp="19acnbpzwl31">
            Organiza tus esenciales, llévalos contigo y haz que cada detalle de
            tu rutina se sienta más fácil, elegante y profesional.
          </p>

          <p className="font-serif italic text-luxury-black mt-8 sm:mt-10 mx-auto max-w-[34ch]" style={{
          fontSize: 'clamp(1.1875rem, 2.6vw, 1.625rem)',
          lineHeight: 1.35
        }} data-id="element-431" data-mp="g4pyitgf9aoc">
            Dos estilos. Una misma esencia. Elige el que va contigo.
          </p>

        </motion.div>
      </div>
    </section>;
}